<script>
  import session from '../lib/session';
  import OrdererPrivateTeams from './OrdererPrivateTeams.svelte';
  import WorkerTeams from './WorkerTeams.svelte';

  export let route_name;
</script>

{#if $session.user.last_role === 'worker'}
  <WorkerTeams {route_name} />
{:else}
  <OrdererPrivateTeams {route_name} />
{/if}
